import React from "react";

import { GridColumn } from "@progress/kendo-react-grid";
import { checkBoxCell, customCell, GridPanel, IRoutedTabProps } from "@selas/ui-components";
import { useTranslation } from "react-i18next";

import Endpoint from "../../../services/api/endpoint";
import { hasPermission } from "../../../services/authentication";
import { Permission } from "../../../utils/enums";
import StatuteEditor from "../../editors/personInfo/statute";

const Statutes: React.FC<IRoutedTabProps> = () => {
	const { t } = useTranslation();

	return (
		<GridPanel
			listEndpoint={Endpoint.StatutesList}
			endpoint={Endpoint.Statutes}
			addScreen={{ screen: StatuteEditor, isAllowed: hasPermission(Permission.StatutesAdd) }}
			editScreen={{ screen: StatuteEditor, isAllowed: hasPermission(Permission.StatutesUpdate) }}
			delete={{ isAllowed: hasPermission(Permission.StatutesDelete) }}
			filter={{
				logic: "and",
				filters: [
					{
						field: "active",
						operator: "eq",
						value: true
					}
				]
			}}
		>
			<GridColumn field="name" title={t("name")} />
			<GridColumn field="active" title={t("active")} filter="boolean" width="160px" cell={customCell(checkBoxCell())} />
		</GridPanel>
	);
};

export default Statutes;
